interface RotaryNavButtonProps {
  direction: 'prev' | 'next';
  label: string;
  onClick: () => void;
  className?: string;
}

/**
 * 丸型回転ナビゲーションボタン。
 * 黒地に緑のシンプルな丸＋矢印＋文字。常時ゆっくり回転し続ける。
 */
export default function RotaryNavButton({
  direction,
  label,
  onClick,
  className = '',
}: RotaryNavButtonProps) {
  const isNext = direction === 'next';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`group relative flex flex-col items-center justify-center rounded-full border border-white/15 bg-black/60 backdrop-blur-md w-24 h-24 md:w-28 md:h-28 text-white hover:border-teal-400/70 hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap ${className}`}
    >
      {/* 常時回転する破線リング */}
      <span className="absolute inset-0 rounded-full border-2 border-dashed border-teal-400/50 rotary-spin pointer-events-none group-hover:border-teal-300/80" />
      {/* 中央の静的リング */}
      <span className="absolute inset-2 rounded-full border border-white/10 pointer-events-none" />
      <i
        className={`${isNext ? 'ri-arrow-right-line' : 'ri-arrow-left-line'} text-2xl text-teal-300 group-hover:text-teal-200 transition-colors`}
      />
      <span className="text-[10px] tracking-[0.25em] uppercase text-white/70 mt-1">{label}</span>
    </button>
  );
}